/** @file heldKeys: the held modifiers and mouse gestures of the viewport (read-only help, not bindings). */

/** Key / gesture and what it does; they are held, not pressed, so they have no binding table. */
export const heldKeys: readonly (readonly [string, string])[] = [
  ['Ctrl + drag', 'Snap the rotation to the snap step'],
  ['Alt + left drag', 'Orbit the camera'],
  ['Middle drag', 'Pan the camera'],
  ['Wheel', 'Zoom (whole-number upscale)'],
];
